/**
 * MER-515: where an authenticated user belongs when they hit the bare
 * domain "/" or finish login without a captured deep link.
 *
 * Pure decision so node:test exercises it directly; the async session +
 * tenant_members reads live in auth.ts (resolveHomePath) and the
 * RootResolver component.
 *
 *   - staff            -> /admin
 *   - has a tenant slug -> /<slug>
 *   - neither           -> null  (signed in but unprovisioned: the caller
 *                                 renders ComingSoon in place and MUST NOT
 *                                 navigate to "/", which would loop the
 *                                 root resolver)
 *
 * @param {{ isStaff: boolean, slug: string | null | undefined }} input
 * @returns {string | null}
 */
export function homePathFor({ isStaff, slug }) {
  if (isStaff) return "/admin";
  if (slug) return `/${slug}`;
  return null;
}
